module.exports = Promise.all([__parcel__import__("3SJSE"), __parcel__import__("b7W7g")]).then(() => parcelRequire('g36Vt'));